import { isPlatformBrowser, NgClass } from '@angular/common';
import {
    afterNextRender,
    ChangeDetectionStrategy,
    Component,
    effect,
    ElementRef,
    inject,
    input,
    output,
    PLATFORM_ID,
    untracked,
    viewChild,
    viewChildren,
    ViewEncapsulation,
} from '@angular/core';
import { polyfill } from 'smoothscroll-polyfill';

@Component({
    selector: 'ui-m060-c010-vehicle-showroom-tabs',
    standalone: true,
    templateUrl: './m060-c010-vehicle-showroom-tabs.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgClass],
})
export class M060C010VehicleShowroomTabsComponent {
    isBrowser = isPlatformBrowser(inject(PLATFORM_ID));

    tabs = input<string[]>();
    currentIndex = input.required<number>();

    tabListContainer = viewChild<ElementRef<HTMLDivElement>>('tabListContainer');
    tabListItem = viewChildren<ElementRef<HTMLButtonElement>>('tabListItem');

    tabClicked = output<number>();

    constructor() {
        afterNextRender({
            write: () => {
                polyfill();
            },
        });
    }

    currentIndexChangedEffect = effect(() => {
        if (!this.isBrowser) return;

        const index = this.currentIndex();
        const tabListContainer = untracked(() => this.tabListContainer())?.nativeElement;
        const tabListItem = untracked(() => this.tabListItem().at(index))?.nativeElement;

        if (!tabListContainer || !tabListItem) return;
        // eslint-disable-next-line @rx-angular/prefer-no-layout-sensitive-apis
        tabListItem.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
    });
}
